import React from "react";
import "./EstimatorBenefits.css";
import sectionImage from "../../../../assets/images/estimator/esti.png";

const points = [
  "Saves time in project planning",
  "Reduces waste and over-ordering",
  "Aligns quantities with IRQGYP's verified systems",
  "Generates instant PDF reports for submittals or client presentations",
  "Accuracy begins with knowledge.",
];

const EstimatorBenefits = ({ onCalculateNow }) => {
  return (
    <section className="estimator-benefits">
      <div className="estimator-benefits__container">
        <div className="estimator-benefits__media">
          <img src={sectionImage} alt="Estimator worker" />
        </div>

        <div className="estimator-benefits__content">
          <h2>
            How can our <span>calculator help you</span>
          </h2>

          <p className="estimator-benefits__subtitle">
            Our calculator gives you the exact materials you need before you start building
          </p>

          <ul>
            {points.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>

          <button className="buttongyp estimator-benefits__btn" type="button" onClick={onCalculateNow}>
            Calculate now
          </button>
        </div>
      </div>
    </section>
  );
};

export default EstimatorBenefits;
